import { defineComponent as _defineComponent } from 'vue'
import { defineMessages } from '@/lib/i18n';
import { reactive, ref } from 'vue';
import { VForm } from 'vuetify/lib/components';

import { store } from '@/store/index';
import sharedMessages from '@/lib/shared-messages';
import BaseButtonSubmit from '@/views/base/BaseButtonSubmit.vue';
import { readAssertedCompany } from '@/store/main/getters';
import { usePermissionComposable } from '@/composables/usePermission';

import { i18n } from '@/plugins/vue-i18n';
import {
  dispatchGetCompany,
  dispatchUpdateCompanySettings,
} from '@/store/main/actionsMain';


export default /*#__PURE__*/_defineComponent({
  __name: 'CompanySdsExpirationForm',
  setup(__props) {

const $t = i18n.t.bind(i18n);
const { hasPermission, PERMISSIONS: P } = usePermissionComposable();
const company = reactive({ ...readAssertedCompany(store) });

const isValidForm = ref<boolean>(false);
const form = ref<InstanceType<typeof VForm> | null>(null);
const isLoading = ref<boolean>(false);
const sdsExpirationYears = ref<number>(company.sds_expiration_years);
const items = Array.from({ length: 10 }, (_, i) => ({
  text: $t(sharedMessages.numberYears, { year: i + 1 }),
  value: i + 1,
}));

const submit = async () => {
  if (!form.value) return;
  const valid = await form.value.validate();
  if (!valid) {
    return;
  }

  isLoading.value = true;
  await dispatchUpdateCompanySettings(store, {
    params: {
      companyId: company.uuid,
    },
    payload: {
      sds_expiration_years: sdsExpirationYears.value,
    },
  });
  await dispatchGetCompany(store, { companyId: company.uuid });
  isLoading.value = false;
};

const m = defineMessages({
  expiration: '経過',
  conditionsForRevision: '要改訂になる条件',
  fromRevisionAndSupplierDate: 'SDS改訂日とサプライヤーへの確認日の両方から',
});

return { __sfc: true,$t, hasPermission, P, company, isValidForm, form, isLoading, sdsExpirationYears, items, submit, m, VForm, sharedMessages, BaseButtonSubmit }
}

})